/**
 * File/Image uploader component
 * This is just a wrapper around input[type="file"] that adds
 * functionality such as image thumbnails, max size validations, etc.
 */

// deps
import PropTypes from 'prop-types';

export default class FileImageUpload extends React.Component {
    static propTypes = {
        wrapperClassName: PropTypes.string,
        fileSizeLimit: PropTypes.number,
        name: PropTypes.string,
        acceptedFiles: PropTypes.string,
        isRequired: PropTypes.bool,
        btnMessage: PropTypes.string,
        displaySelectedFileName: PropTypes.bool
    };

    static defaultProps = {
        wrapperClassName: '',
        fileSizeLimit: 3,
        name: '',
        acceptedFiles: 'image/jpeg, application/pdf',
        isRequired: false,
        btnMessage: 'Browse Files',
        displaySelectedFileName: false
    };

    constructor() {
        super();

        this.state = {
            invalidFileSize: false,
            selectedFiles: [],
            documentType: ''
        };
    }

    _onChangeHandler = (e) => {
        const fileArray = [...e.target.files];
        const validFileSize = this._validateFileSize(fileArray);

        this._toggleFileSizeError(!validFileSize);
        this._updateSelectedFiles(fileArray);

        if (!validFileSize) {
            e.target.value = '';

            this._updateSelectedFiles();

            return;
        }
    }

    _validateFileSize = (files = []) => {

        let isValid = true;

        files.forEach((file) => {
            if ((file.size / (1024 * 1024)) > this.props.fileSizeLimit) {
                isValid = false;
            }

            return isValid;
        });

        return isValid;
    }

    _updateSelectedFiles = (files = []) => {

        const filesNameArr = files.map((el) => el.name);
        const fileExt = files[0].name.slice((files[0].name.lastIndexOf('.') - 1 >>> 0) + 2);

        this.setState({ selectedFiles: filesNameArr, documentType: fileExt });
    }

    _toggleFileSizeError = (error = true) => this.setState({ invalidFileSize: error });

    _renderSelectedFileName = (files = []) => files.map((el, index) => (<span key={`file-${index}`} className="selected-file-upload">{el}</span>))

    render() {

        return (
            <div className={`${this.props.wrapperClassName} control-wrapper`}>
                <label className="form-submit-button file-image-uploader-control" htmlFor="file-image-uploader">{this.props.btnMessage}</label>
                {
                    this.state.invalidFileSize && <span className="form-error">{`Invalid file size, please choose a file under ${this.props.fileSizeLimit}MB`}</span>
                }
                {
                    (this.props.displaySelectedFileName && this.state.selectedFiles.length > 0) && this._renderSelectedFileName(this.state.selectedFiles)
                }
                <input
                    type="file"
                    accept={ this.props.acceptedFiles }
                    name={ this.props.name }
                    id="file-image-uploader"
                    onChange={ this._onChangeHandler }
                    required={ this.props.isRequired }
                />
                <input
                    type="text"
                    name="documentType"
                    id="documentType"
                    value={this.state.documentType}
                />
            </div>
        );
    }
}
